import { render, staticRenderFns } from "./resubmit.vue?vue&type=template&id=5b073e70&scoped=true&"
import script from "./resubmit.vue?vue&type=script&lang=js&"
export * from "./resubmit.vue?vue&type=script&lang=js&"
import style0 from "./resubmit.vue?vue&type=style&index=0&id=5b073e70&prod&scoped=true&lang=css&"
import style1 from "./resubmit.vue?vue&type=style&index=1&id=5b073e70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b073e70",
  null
  
)

export default component.exports